import { createActions } from 'redux-actions'

const creators = createActions({
  GET_LATEST_POINTS: ({ userId }) => ({ userId }),
  SET_LATEST_POINTS: (payload) => payload
});

export default creators
